// fsdir.ts — DirWriter over a FileSystemDirectoryHandle. Works identically for
// a user-picked directory (showDirectoryPicker) and the Origin Private File
// System root (navigator.storage.getDirectory()) — the latter needs no
// permission prompt, which is what the automated E2E uses.
import type { DirWriter } from "./pull.ts";

export function handleWriter(root: FileSystemDirectoryHandle): DirWriter {
  const dir = async (rel: string[], create: boolean) => {
    let d = root;
    for (const part of rel) d = await d.getDirectoryHandle(part, { create });
    return d;
  };
  return {
    async file(rel) {
      const d = await dir(rel.slice(0, -1), true);
      const fh = await d.getFileHandle(rel[rel.length - 1], { create: true });
      return await fh.createWritable();   // truncates
    },
    async size(rel) {
      try {
        const d = await dir(rel.slice(0, -1), false);
        const fh = await d.getFileHandle(rel[rel.length - 1]);
        return (await fh.getFile()).size;
      } catch {
        return null;
      }
    },
    async exists(name) {
      try {
        await root.getDirectoryHandle(name);
        return true;
      } catch {
        return false;
      }
    },
    async readText(rel) {
      const d = await dir(rel.slice(0, -1), false);
      const fh = await d.getFileHandle(rel[rel.length - 1]);
      return await (await fh.getFile()).text();
    },
  };
}
